import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { Placeholder } from '@lmn/design-system';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

export function PriceTypeTextX(props: {
  price: number | undefined;
  roomsIncludedInPrice: number | undefined;
  nights: number | undefined;
  isDoublePriceDP: boolean | undefined;
}) {
  const { t } = useTranslation();
  const { localization } = usePageWrapperData();
  const { price, roomsIncludedInPrice = 1, nights, isDoublePriceDP = false } = props;

  const text = price
    ? isDoublePriceDP
      ? `${formatPrice({ price, localization })} ${t('vacation.common.doubleprice.total_dp')}`
      : roomsIncludedInPrice > 1
        ? nights === 1
          ? t('vacation.select.room.price.includes.total.rooms.night', {
              price: formatPrice({ price, localization }),
              rooms: roomsIncludedInPrice.toString(),
              nights: nights?.toString() || '',
            })
          : t('vacation.select.room.price.includes.total.rooms.nights', {
              price: formatPrice({ price, localization }),
              rooms: roomsIncludedInPrice.toString(),
              nights: nights?.toString() || '',
            })
        : nights === 1
          ? t('vacation.select.room.price.includes.total.night', {
              nights: nights?.toString() || '',
            })
          : t('vacation.select.room.price.includes.total.room.nights', {
              price: formatPrice({ price, localization }),
              nights: nights?.toString() || '',
            })
    : '';

  return text ? <span>{text}</span> : <Placeholder height="17px" width="100px" />;
}
